import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RouterState } from '../reducers/router.reducer';

export const STORE_NAME = 'router';

export const routerState = createFeatureSelector<RouterState>(STORE_NAME);

export const selectParams = createSelector(routerState, (state: RouterState) => (state ? state.state.params : {}));

export const selectQueryParams = createSelector(routerState, (state: RouterState) => (state ? state.state.queryParams : {}));
